<h1 mat-dialog-title>Process</h1>
<mat-dialog-content>
  <dg-listbox
    [content]="content2"
    [columnConfig]="columnConfig2"
    [multiple]="false"
    (output)="getData($event)"
  >
    <ng-container class="listbox-search-placeholder"> Search</ng-container>
  </dg-listbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Close</button>
  <button mat-raised-button color="primary" (click)="onSubmitClick()">
    Submit
  </button>
</mat-dialog-actions>
